import { render } from "./DropZonePdf.vue?vue&type=template&id=4a44f2e0&scoped=true"
import script from "./DropZonePdf.vue?vue&type=script&lang=js"
export * from "./DropZonePdf.vue?vue&type=script&lang=js"

import "./DropZonePdf.vue?vue&type=style&index=0&id=4a44f2e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a44f2e0"]])

export default __exports__